import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMainNewsSucceed, EGetMainNewsActionType } from './types';
import { TMainNewsItem } from '../../../types/mainNews';

export const getMainNewsSucceed: (items: TMainNewsItem[]) => TGetMainNewsSucceed = actionGenerator<
  EGetMainNewsActionType.Succeed,
  TMainNewsItem[]
>(EGetMainNewsActionType.Succeed);
